import { render, staticRenderFns } from "./ClassAutocomplete.vue?vue&type=template&id=34f40752&scoped=true&"
import script from "./ClassAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ClassAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f40752",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34f40752')) {
      api.createRecord('34f40752', component.options)
    } else {
      api.reload('34f40752', component.options)
    }
    module.hot.accept("./ClassAutocomplete.vue?vue&type=template&id=34f40752&scoped=true&", function () {
      api.rerender('34f40752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/classes/ClassAutocomplete.vue"
export default component.exports